import { css } from '@emotion/react';
import { Box } from '@spark-web/box';
import { Heading } from '@spark-web/heading';
import { ContentDialog, DialogClose } from '@spark-web/modal-dialog';
import { useTheme } from '@spark-web/theme';
import { forwardRef, ReactNode } from 'react';

export type FilterSortBaseDialogProps = {
  isOpen: boolean;
  onToggle: () => void;
  onCloseAutoFocus?: (event: Event) => void;
  title: string;
  children: ReactNode;
  formId?: string;
  onSubmit?: (e?: React.BaseSyntheticEvent) => Promise<void>;
};

export const FilterSortBaseDialog = forwardRef<HTMLDivElement, FilterSortBaseDialogProps>(
  ({ isOpen, onToggle, onCloseAutoFocus, title, children, formId, onSubmit }, _ref) => {
    const theme = useTheme();

    return (
      <ContentDialog
        height="full"
        position="start"
        isOpen={isOpen}
        padding="none"
        onToggle={onToggle}
        onCloseAutoFocus={onCloseAutoFocus}
        css={css({
          height: '100vh',
          borderRadius: 0,
          [`@media (min-width: ${theme.breakpoint.mobile}px)`]: {
            width: '100vw',
          },
          [`@media (min-width: ${theme.breakpoint.tablet}px)`]: {
            width: '50vw',
          },
          [`@media (min-width: ${theme.breakpoint.desktop}px)`]: {
            width: '35vw',
            maxWidth: '35vw',
          },
        })}
      >
        <Box paddingBottom="large">
          <Box display="flex" justifyContent="end">
            <DialogClose />
          </Box>
          <Heading level="3">{title}</Heading>
        </Box>
        <form
          id={formId}
          onSubmit={onSubmit}
          style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
        >
          {children}
        </form>
      </ContentDialog>
    );
  },
);

FilterSortBaseDialog.displayName = 'FilterSortBaseDialog';
